import { Link as FuiLink, type LinkProps } from '@fluentui/react-components';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const Link = createLink<'a'>(
    forwardRef<HTMLAnchorElement, Omit<LinkProps, 'as'>>((props, ref) => (
        <FuiLink {...(props as any)} as="a" ref={ref} />
    ))
);
